export const categories = [
  {
    id: "1",
    categoryName: "🔥Trending",
  },
  {
    id: "2",
    categoryName: "✨Latest",
  },
  {
    id: "3",
    categoryName: "🐼Old",
  },
];
